import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { AsyncPipe, CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { ActivityType, ObjectType } from '../../../tokens-and-interfaces';
import { TranslationModule } from '../../../i18n/translation-module';
import { TranslateByObjectTypePipe } from '../../../i18n/translate-by-object-type/translate-by-object-type.pipe';

export interface DialogData {
  objectType: ObjectType;
  name$: Observable<string>;
}

@Component({
  selector: 'crm-delete-modal',
  templateUrl: './delete-modal.component.html',
  styleUrls: ['./delete-modal.component.scss'],
  imports: [CommonModule, MatButtonModule, TranslationModule, MatDialogModule, AsyncPipe, TranslateByObjectTypePipe],
  standalone: true,
})
export class DeleteModalComponent {
  objectType: ObjectType | ActivityType;

  name$: Observable<string | undefined>;

  constructor(@Inject(MAT_DIALOG_DATA) public data: DialogData, private dialogRef: MatDialogRef<DeleteModalComponent>) {
    this.objectType = data.objectType;
    this.name$ = data.name$;
  }

  onConfirmClick() {
    this.dialogRef.close(true);
  }
}
